// src/servicos/geocodingServico.js

export const GOOGLE_API_KEY = "AIzaSyCbb3DcgKR_Skx-rDVtkz8PnSV0Kmu66C0";


// --------------------
// Buscar endereço (texto -> coordenadas)
// Usando agora somente Google Places API
// --------------------
export const buscarEndereco = async (textoBusca) => {
  try {
    console.log('Buscando endereço no Google...');

    // 1️⃣ Autocomplete para obter o Place ID
    const respostaAutocomplete = await fetch(
      `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodeURIComponent(
        textoBusca
      )}&types=establishment|geocode&language=pt-BR&components=country:br&key=${GOOGLE_API_KEY}`
    );
    const dadosAutocomplete = await respostaAutocomplete.json();

    console.log('dados retornados: ');
    console.log(dadosAutocomplete);

    if (!dadosAutocomplete.predictions || dadosAutocomplete.predictions.length === 0) {
      return null;
    }

    const placeId = dadosAutocomplete.predictions[0].place_id;

    // 2️⃣ Place Details para obter coordenadas e endereço formatado
    const respostaPlaceDetails = await fetch(
      `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&language=pt-BR&key=${GOOGLE_API_KEY}`
    );
    const dadosPlaceDetails = await respostaPlaceDetails.json();

    if (!dadosPlaceDetails.result) {
      return null;
    }

    const lugar = dadosPlaceDetails.result;
    return {
      lat: lugar.geometry.location.lat,
      lng: lugar.geometry.location.lng,
      endereco: lugar.formatted_address,
      fonte: "google",
    };

  } catch (err) {
    console.error("Erro em buscarEndereco:", err);
    return null;
  }
};

// --------------------
// Buscar coordenadas -> endereço
// Mantendo Nominatim como principal, Google como fallback
// --------------------
export const buscarEnderecoPorCoordenada = async (lat, lng) => {
  try {
    const respostaGoogle = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=pt-BR&key=${GOOGLE_API_KEY}`
    );
    const dadosGoogle = await respostaGoogle.json();

    if (dadosGoogle.results && dadosGoogle.results.length > 0) {
      return {
        endereco: dadosGoogle.results[0].formatted_address,
        fonte: "google",
      };
    }

    return null;
  } catch (err) {
    console.error("Erro em buscarEnderecoPorCoordenada:", err);
    return null;
  }
};
